import { belongsTo } from '@ember-data/model';
import Super from './document-request';

export default class DocumentRequestCreditCardInfo extends Super {
  documentIcon = 'credit-card';
  mixpanelType = 'Credit card form';

  @belongsTo('card', { async: false, inverse: null }) card;
}
